import ChatClockView from "./ChatClockItem"

export default ChatClockView
